import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/environment';

@Pipe({
    name: 'apiUrl',
    standalone: false
})
export class ApiUrlPipe implements PipeTransform {

  transform(value: any, cacheBuster?: string | number): any {
    const url = environment.apiUrl + value;
    return cacheBuster ? `${url}?v=${cacheBuster}` : url;
  }
}
